module.exports = __webpack_public_path__ + "static/media/refresh-blue.bba5a370.svg";